import { RouteState } from './route.types';

import { RootState } from '~/redux/store';

export const selectCurrentRoute = ({
  route,
}: RootState): RouteState['currentRoute'] => route.currentRoute;

export const selectRouteHistory = ({
  route,
}: RootState): RouteState['routeHistory'] => route.routeHistory;
